module.exports = __webpack_public_path__ + "img/zep2.5530f858.jpg";